import React from 'react';
import PropTypes from 'prop-types';
import PfptLabelWithInfo from '../../PfptLabelWithInfo/PfptLabelWithInfo';

export default function ContentRuleName({ isDefault, name }) {
    return isDefault
        ? <PfptLabelWithInfo
            tooltip="This is the Default Content Rule assigned if there are no other previous matches."
            tooltipText=""
        >
            {name}
        </PfptLabelWithInfo>
        : name;
}

ContentRuleName.propTypes = {
    isDefault: PropTypes.bool,
    name: PropTypes.string.isRequired,
};
